export const isSkilljarHost =
  window.location.hostname.includes('campus-signup');
